module.exports = __webpack_public_path__ + "img/chris (4).6310282a.jpg";